import * as types from './types'

const mutations = {
	[types.LOGIN]: (state, data) => {
		localStorage.setItem('token', data)
		// localStorage.token = data
		state.token = data
	},
	[types.LOGOUT]: (state) => {
		localStorage.removeItem('token');
		state.token = null
	},
	[types.USERNAME]: (state, data) => {
		localStorage.setItem('userName', data)
		state.userName = data
	},
	[types.USERID]: (state, data) => {
		localStorage.setItem('userId', data)
		state.userId = data
	},
	UpdateState: (state,data) => {
		Object.keys(data).forEach(item => {
			state[item] = data[item]
		})
	}
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js